<template>
  {{ price }}
</template>

<script>
import { priceToDollars }  from '../../../helpers.js'

export default {
  props: ['collection'],
  computed: {
    price() {
      return this.collection.status == 'fiat_sale'
      ? priceToDollars(this.collection.fiat_price)
      : this.collection.ethPrice
    }
  }
}
</script>

<style lang="scss">

</style>